export var EventTypeError;
(function (EventTypeError) {
    EventTypeError["SessionExpired"] = "error-session-expired";
    EventTypeError["OidcConfiguration"] = "error-oidc-configuration";
    EventTypeError["SystemCurrentlyUnavailable"] = "error-system-currently-unavailable";
})(EventTypeError || (EventTypeError = {}));
